let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l2LZP")).then(() => parcelRequire('iDsnj'));